"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { usePathname } from "next/navigation";
import { getCookie } from "cookies-next/client";
import { useCurrentUser } from "@/store/useUserStore";
import { userQueryServiceForUsers } from "../../services/users/UserQueryService";
export const useCurrentUserQuery = () => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getCookie("jwt");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const token = t0;
  const queryClient = useQueryClient();
  const pathname = usePathname();
  const currentUser = useCurrentUser();
  let t1;
  if ($[1] !== currentUser || $[2] !== queryClient) {
    t1 = () => {
      if (token && !currentUser) {
        queryClient.invalidateQueries({
          queryKey: ["current-user"]
        });
      }
    };
    $[1] = currentUser;
    $[2] = queryClient;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== currentUser || $[5] !== pathname || $[6] !== queryClient) {
    t2 = [pathname, token, queryClient, currentUser];
    $[4] = currentUser;
    $[5] = pathname;
    $[6] = queryClient;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["current-user"];
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      queryKey: t3,
      queryFn: _temp,
      enabled: Boolean(token),
      retry: 3,
      refetchOnWindowFocus: true
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return useQuery(t4);
};
function _temp() {
  return userQueryServiceForUsers.fetchCurrentUser();
}